import styled from '../../lib/theme';

export const ColorSelectorContainer = styled.div`
  display: flex;
  position: relative;
  align-items: center;
`;

interface IColorBoxProps {
  color: string;
}

export const ColorBox = styled.div<IColorBoxProps>`
  height: 25px;
  width: 25px;
  margin-right: 8px;
  border-color: #000;
  border-width: 2px;
  border-style: solid;

  ${({ color }) => `
        background-color: ${color};
    `}
`;

export const ColorPickerContainer = styled.div`
  position: absolute;
  left: 10px;
  top: 10px;
  z-index: 99;
`;
